<template>
    <div class="Subtopic-outer video-list">
        <div v-if="videoList && videoList.mainConcept.length">
            <div class="related-video">Related Videos</div>
            <div class="main-concept">Main Concept</div>
            <div v-for="vl in videoList.mainConcept" :key="vl.id">
                <v-row>
                    <v-col class="video-pad-3may" cols="12">
                        <!-- <iframe class="video-frame" allow="fullscreen;" :src="'https://www.youtube.com/embed/'+vl.id"></iframe>     -->
                        <youtube  class="video-frame" :video-id="vl.id" ref="youtube" @playing="playing(vl.id)" @ended="ended(vl.id)" @paused="paused(vl.id)"></youtube>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div v-if="videoList && videoList.subTopic.length">       
            <div class="sub-topic">Related Concept</div>
            <div>
                <v-row>
                    <v-col class="video-pad-3may" cols="6" v-for="vl in videoList.subTopic" :key="vl.id">
                        <!-- <iframe  class="related-video-frame" allow="fullscreen;" :src="'https://www.youtube.com/embed/'+vl.id"></iframe> -->
                        <youtube class="related-video-frame" :video-id="vl.id" ref="youtube" @playing="playing(vl.id)" @ended="ended(vl.id)" @paused="paused(vl.id)"></youtube>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div v-if="videoList && videoList.taggedConcepts.length">
            <div v-for="vl in videoList.taggedConcepts" :key="vl.id">
                <div v-for="v in vl.videos" :key="v.id">
                    <div class="tagged-video-row">
                        <div class="tagged-video-col-2">
                            <!-- <iframe class="tagged-video" allow="fullscreen;" :src="'https://www.youtube.com/embed/'+v.id"></iframe> -->
                            <youtube class="tagged-video" :video-id="v.id" ref="youtube" @playing="playing(v.id)" @ended="ended(v.id)" @paused="paused(v.id)"></youtube>
                        </div>
                        <div class="tagged-video-col-10"> 
                            
                            <div class="video-name">
                                <label> {{v.title && v.title.length < 99
                                    ? v.title
                                    : v.title.substring(0, 100) + "..."}} </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState, mapActions } from "vuex";

export default {
    name: "VideoList",
    data() {
        return{
            videoId:{},
            playingVideosList:[],
            isPlaying:false
        }
    },
    props: ["videoList", "test_id", "question_id"],
    methods: {
        ...mapActions({
            saveEvent: "testStore/saveEvent",
        }),
        updateEvent(id) {
            let startTime=this.videoId[id];
            let postData= {
                event_name: "show-video",
                start_time: startTime,
                test_id: this.test_id + "",
                question_id: this.question_id + "",
            }
            return postData;
        },
        playing(id) {
            this.playingVideosList.push(id);
            let videoPlayTime = moment().format().toLocaleString();
            this.videoId = Object.assign({ [id]: videoPlayTime }, this.videoId);
        },
        paused(id) {
            for(let i=0;i<this.playingVideosList.length;i++){
                if(this.playingVideosList[i]==id){
                    this.playingVideosList.splice(i, 1);
                    break;
                }
            }
            let reqData = this.updateEvent(id);
            this.saveEvent(reqData);
            for(let i=0;i<this.playingVideosList.length;i++){
                if(this.playingVideosList[i]==id){
                    this.isPlaying=true;
                    break;
                }
            }
            if(!this.isPlaying){
                delete this.videoId[id];
            }
            this.isPlaying=false;
        },
        ended(id) {
            for(let i=0;i<this.playingVideosList.length;i++){
                if(this.playingVideosList[i]==id){
                    this.playingVideosList.splice(i, 1);
                    break;
                }
            }
            let reqData = this.updateEvent(id);
            this.saveEvent(reqData);
            for(let i=0;i<this.playingVideosList.length;i++){
                if(this.playingVideosList[i]==id){
                    this.isPlaying=true;
                    break;
                }
            }
            if(!this.isPlaying){
                delete this.videoId[id];
            }
            this.isPlaying=false;
        },
    }
};
</script>
